
<template>
  <div class="container-fluid p-0 m-0" >
    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0">
        <div class="input-group">
          <span class="input-group-prepend">
            <span class="input-group-text"><i class="icon-calendar22"></i></span>
          </span>
          <input type="text" v-bind:id="'calender' + getId()" class="form-control" value="">
        </div>
      </div>
    </div>
    <div class="row p-0 m-0" style="position:relative;">
      <div style="position:absolute" v-bind:id="'calenderparent' + getId()"></div>
    </div>
    

  </div>

</template>

<script>

  import moment from 'moment'
  var value = null;

	export default {
    name: 'input-inline-date',
		components: {
    },
    props: {
      onchangeddatefunction: {
        required: false,
        type: String,
        default: null
      },
      drops: {
        required: false,
        type: String,
        default: 'down'
      },
      
    },
    methods: {
      setDate(date) {
        this.value = date;
        var daterangepicker = $('#calender' + this.getId()).data("daterangepicker");
        if (date == null || date == '') {
          $('#calender' + this.getId()).val(null)
          //daterangepicker.setStartDate('');
        }
        else {
          //var d = this.$store.getMomentLocale(date);
          //alert("setStartDate:" + d.format("L"))
          $('#calender' + this.getId()).val(date)
          //daterangepicker.setStartDate(date);
          //daterangepicker.setEndDate(null);
        }
      },
      getId() {
        return this._uid;
      },
      daterangeChanged(date) {
        var copydate = JSON.parse(JSON.stringify(date))
        this.$emit('changed', copydate);
        if (this.onchangeddatefunction != null) {
          eval(this.onchangeddatefunction + "(copydate)")
        }
      },
      
      initCalender(date) {
        var locale = $.datepicker.regional[this.$store.getExtendedLocale()];
        var d = this.$store.getMomentLocale(date);
        
        var settings = {
          parentEl: '#calenderparent' + this.getId(),
          autoUpdateInput: false,
          locale: locale,
          singleDatePicker: true,
          startDate: d,
          onSelect: function (ev, picker)  {

            
          },
          onChangeMonthYear: function () {
            //alert('o');
          },
          drops: this.drops
        };
        var thisContext = this;

        $('#calender' + this.getId()).daterangepicker(settings, function (start, end, label) {
          var tmp = thisContext.$store.getMomentLocale(start);
          $('#calender' + thisContext.getId()).val(tmp.format("L"));
          thisContext.daterangeChanged(start, end, label)

        });

        // Set to empty value first
        $('#calender' + this.getId()).val(d.format("L"))

        //$('#calender' + this.getId()).on('apply.daterangepicker', function (ev, picker) {
          //alert();
        //});
      }
      
    },
    data() {
      return {
      }
    },
    created() {
      
    },
    mounted() {
      this.initCalender(new Date());
    },
    computed: {
      
    },
    watch: {
      
    }
}
</script>

<style scoped>
  
</style>

<style>
  /*.daterangepicker {
    position: relative !important;
    left:0px;
  }*/
  .content-inner{

  }
</style>



// WEBPACK FOOTER //
// src/components/form-components/input-inline-date.vue